<template>
  <img src="/logo-light.svg" />
</template>
